











































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';
@Component({
  components: {},
})
export default class TextareaInput extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  @Prop() private formProp: any;

  private form: any = {};

  created() {}

  mounted() {
    if (JSON.stringify(this.formProp) == '{}') {
      this.form = {
        id: uuid(),
        label: '单行输入框',
        placeholder: '请输入内容',
        required: true,
        scan: false,
        // print: false,
      };
      this.$nextTick(() => {
        this.$emit('unit_set_data', { id: this.unitId, form: this.form });
      });
    } else {
      this.form = this.formProp;
    }
    console.log(this.form);
  }

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
  beforeClose(done: any) {
    this.$emit('unit_set_data', { id: this.unitId, form: this.form });
    done();
  }
}
